import { createSlice } from "@reduxjs/toolkit";
import { showNotification } from "../../components/Notification";
import {
  createDepartment,
  deleteDepartment,
  getAllDepartment,
  updateDepartment,
} from "../../api/departmentApi";

const initialState = {
  departments: [],
  loading: false,
  status: "idle",
};

const departmentSlice = createSlice({
  name: "departmentState",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllDepartment.pending, (state) => {
        state.loading = true;
        state.status = "loading";
      })
      .addCase(getAllDepartment.fulfilled, (state, action) => {
        state.loading = false;
        state.status = "succeeded";
        state.departments = action.payload;
      })
      .addCase(getAllDepartment.rejected, (state, action) => {
        state.loading = false;
        state.status = "failed";
        state.error = action.payload;
        showNotification("error", action.payload?.message);
      })
      .addCase(createDepartment.pending, (state) => {
        state.loading = true;
        state.status = "loading";
      })
      .addCase(createDepartment.fulfilled, (state, action) => {
        state.loading = false;
        state.status = "succeeded";
        state.departments.push(action.payload);
        showNotification(
          "success",
          "The Business Unit has been successfully created."
        );
      })
      .addCase(createDepartment.rejected, (state, action) => {
        state.loading = false;
        state.status = "failed";
        state.error = action.payload;
        showNotification("error", action.payload?.message);
      })
      .addCase(deleteDepartment.pending, (state) => {
        state.loading = true;
        state.status = "loading";
      })
      .addCase(deleteDepartment.fulfilled, (state, action) => {
        state.loading = false;
        state.status = "succeeded";
        state.departments = state.departments.filter(
          (item) => item.id !== action.payload
        );
        showNotification(
          "success",
          "The Business Unit has been successfully deleted."
        );
      })
      .addCase(deleteDepartment.rejected, (state, action) => {
        state.loading = false;
        state.status = "failed";
        state.error = action.payload;
        showNotification("error", action.payload?.message);
      })
      .addCase(updateDepartment.pending, (state) => {
        state.loading = true;
        state.status = "loading";
      })
      .addCase(updateDepartment.fulfilled, (state, action) => {
        state.loading = false;
        state.status = "succeeded";
        state.departments = state.departments.map((department) =>
          department.id === action.payload.id ? action.payload : department
        );
        showNotification(
          "success",
          "The Business Unit has been successfully updated."
        );
      })
      .addCase(updateDepartment.rejected, (state, action) => {
        state.loading = false;
        state.status = "failed";
        state.error = action.payload;
        showNotification("error", action.payload?.message);
      });
  },
});

export const departmentState = (state) => state.departmentState;
export const getDepartment = (state) => state?.departmentState.departments;

export default departmentSlice.reducer;
